{
    "accessInstructions": {
        "connecting": "Connecting to servers...",
        "joinSession": "Join the session",
        "loadingMedia": "Loading video stream...",
        "useMachine": "Use my Cloud PC"
    },
    "common": {
        "action": {
            "acknowledge": "Well noted!",
            "cancel": "Cancel",
            "captureCursor": "Capture cursor",
            "close": "Close",
            "connect": "Connect",
            "createGroupSession": "Create group session",
            "disable": "Disable",
            "disconnect": "Disconnect",
            "downloadUsbAgent": "Download USB Agent (Windows x64)",
            "downloadUsbAgentUpdate": "Download update of the USB agent",
            "enableWebcam": "Enable webcam",
            "endSession": "End Session",
            "exclude": "Exclude",
            "exit": "Exit",
            "exitFullscreen": "Exit full screen",
            "fold": "Fold",
            "freeCursor": "Free cursor",
            "giveControlTo": "Give control to {user}",
            "joinSupervisionRoom": "Join the room",
            "keepControl": "Keep control",
            "keepSessionOpen": "Keep my session open",
            "loading": "Loading...",
            "manageGroupSession": "Manage group session",
            "measure": "Measure",
            "ok": "Ok",
            "putMachineInSleepMode": "Put my Cloud PC to sleep",
            "quitSession": "Quit the session",
            "reconnect": "Reconnect",
            "requestControl": "Request control",
            "restart": "Restart",
            "restartUpdateDetection": "Restart update detection",
            "retryConnection": "Retry connection",
            "returnToSupervisionRoom": "Return to supervision room",
            "send": "Send",
            "showDebug": "Show debug",
            "showMenu": "Show menu",
            "showTips": "Show tips",
            "startTest": "Start Test",
            "stop": "Stop",
            "suspend": "Suspend",
            "takeControlByForce": "Take control by force",
            "understood": "Understood",
            "unenrollFromSupervisionRoom": "Leave the supervision room",
            "unfold": "Unfold",
            "unlock": "Unlock",
            "validate": "Validate"
        },
        "error": {
            "unexpected": "An unexpected error has occurred. Please contact support if the error persists.",
            "validation": "Invalid fields have been detected."
        },
        "label": {
            "acceptableDelay": "Acceptable Delay",
            "agentConnected": "Agent connected",
            "androidControlPanelInstructions": "Android control panel instructions",
            "audio": "Audio",
            "autoDisconnect": "Auto Disconnect After Inactivity Period (20 minutes)",
            "averageVideoBitrate": "Average Video Bitrate",
            "backspace": "Backspace",
            "bandwidth": "Bandwidth",
            "bitsReceived": "Bits received",
            "bytes": "bytes",
            "changeRequest": "Change request",
            "commercial": "Commercial",
            "configuration": "Configuration",
            "connectedTo": "Connected to {room}",
            "controlPanel": "Control panel",
            "customCommand": "Custom command",
            "debugLocalCapture": "Debug (local capture)",
            "defaultUser": "Default user",
            "delete": "Del",
            "description": "Description",
            "display": "Display",
            "duration": "Duration",
            "fast": "Fast",
            "fileTooLarge": "File Too Large",
            "fileTransfer": "File transfer",
            "fps": "FPS",
            "fpsOptimization": "Video optimization",
            "framesDropped": "Frames dropped",
            "fullscreen": "Fullscreen",
            "fullscreenMode": "Fullscreen Mode",
            "general": "General",
            "groupSessionLink": "Link to your sharing session",
            "host": "Host",
            "incident": "Incident",
            "interaction": "Interaction",
            "interactionLatency": "Interaction latency",
            "iosFullscreenInstructions": "iOS fullscreen instructions",
            "ipv4Address": "IPv4 Address",
            "ipv6Address": "IPv6 Address",
            "jitter": "Jitter",
            "kb": "KB",
            "latency": "Latency",
            "live": "Live",
            "localResolution": "Local resolution",
            "macAddress": "MAC Address",
            "machineLocked": "Locked Cloud PC",
            "mb": "MB",
            "mbPerSecond": "MB/s",
            "metricsPanel": "Metrics panel",
            "metricsPanelDisplay": "Metrics panel display",
            "mouseFunctionality": "Mouse functionality",
            "mouseWheelScrollSensitivity": "Mouse Wheel Scroll Sensitivity",
            "name": "Name",
            "network": "Network",
            "normal": "Normal",
            "other": "Other",
            "owner": "Owner",
            "packetsLate": "Packets late",
            "packetsLost": "Packets lost",
            "packetsReceived": "Packets received",
            "participantList": "List of participants",
            "password": "Password",
            "preconfiguredShortcuts": "Preconfigured shortcuts",
            "pressKeys": "Press keys...",
            "problem": "Problem",
            "problemDetected": "Problem detected",
            "remoteResolution": "Remote resolution",
            "resolution": "Resolution",
            "results": "Results",
            "seconds": "seconds",
            "server": "Server",
            "settings": "Settings",
            "sharingInProgress": "Sharing in progress",
            "sideMenu": "Side Menu",
            "sideMenuBurgerButtonDisplay": "Side Menu Burger Menu Button Display",
            "sideMenuShortcut": "Side menu shortcut",
            "slow": "Slow",
            "spiceDriver": "Spice VDAgent Driver",
            "supervisedBy": "Supervised by {supervisor}",
            "timeRemaining": "Time remaining: {0}",
            "totalDataConsumption": "Total Data Consumption",
            "transferError": "Transfer Error",
            "transferSuccess": "Transfer Successful",
            "type": "Type",
            "updateAvailable": "Update available",
            "upscaleMode": "Upscale Mode",
            "usbAgentConnectionError": "Failed to Connect to Agent",
            "usbAgentDisconnected": "Agent disconnected",
            "usbAgentError": "An Error Occurred",
            "usbAgentGuiDisconnected": "Unable to Get Device List",
            "usbAgentUpdateDetected": "Agent Updated",
            "usbAgentUpdateNotDetected": "Update Not Detected",
            "usbDeviceConnected": "Device Connected",
            "usbDeviceDisconnected": "Device Disconnected",
            "usbDeviceError": "Device Connection Error",
            "usbDevicePending": "Device Connecting",
            "usbDevices": "Usb Devices (Beta)",
            "user": "User",
            "userRequest": "User request",
            "userReturn": "User return",
            "veryFast": "Very fast",
            "verySlow": "Very slow",
            "video": "Video",
            "videoQuality": "Video quality",
            "videoQualityLow": "Low (180p)",
            "webcam": "Webcam",
            "webcamConnected": "Webcam Connected",
            "windowed": "Windowed"
        },
        "sentence": {
            "androidMachinesRequireTouchDevice": "Our Android Cloud PCs are currently accessible only with a touch device (smartphone or tablet).",
            "awaitingUserResponse": "Waiting for {user}'s response...",
            "canDisableInSettings": "(You can disable this feature in the settings)",
            "changePasswordInSystemPreferences": "You can change your password at any time in your system preferences.",
            "clipboardNotSupported": "Clipboard is not supported in this browser.",
            "clipboardPermissionRequired": "You should allow clipboard access to copy and paste text.",
            "cloudPcAutoSleepIn": "Your Cloud PC will automatically go to sleep in",
            "cloudPcPoweredOff": "The connection to your Cloud PC has been interrupted because it is no longer powered on.",
            "connectionDetectionInProgress": "Automatic connection detection in progress...",
            "connectionFailure": "The connection to your Cloud PC has been interrupted due to a network problem.",
            "connectionInterruptedByInactivity": "The connection with your Cloud PC has been interrupted due to inactivity.",
            "controlBeingTransferred": "Control is being transferred.",
            "controlForciblyLostInfo": "{user} has taken control of this Cloud PC.",
            "controlForciblyTaken": "You have taken control of this Cloud PC.",
            "controlGained": "You have gained control of this Cloud PC.",
            "controlPanelDescription": "Exit full screen mode, manage power and more with the control panel.",
            "controlRegainedReconnecting": "You have regained control of your Cloud PC, reconnecting.",
            "controlRequestAccepted": "Your control request has been accepted.",
            "controlRequestCancelled": "Your control request has been cancelled.",
            "controlRequestCancelledByUser": "{user} has cancelled their control request.",
            "controlRequestExpiredForUser": "{user}'s control request has expired.",
            "controlRequestExpiredRetrying": "Your control request has expired, retrying...",
            "controlRequestNotifiesUserForApproval": "The user will be notified of a control request that they can accept or refuse.",
            "controlRequestRefused": "The user refused your control request.",
            "controlRequestRefusedInfo": "Your control request has been refused by {user}.",
            "controlRetained": "You retain control of this Cloud PC.",
            "controlTransferredTo": "Control transferred to {user}.",
            "controlTransferredToUserInfo": "Control has been transferred to {user}.",
            "cursorModeExplanation": "By capturing the cursor, cursor movements are limited to your Cloud PC screen.\nIn non-captured mode, the cursor can pass from the Cloud PC to other windows of your local environment.\nCaptured mouse mode is recommended for games or graphic applications.",
            "dataSaved": "Your data is saved.",
            "disconnectedSupervisionRoomEnded": "You have been disconnected because the supervised session has ended.",
            "doNotShowAgain": "Do not show this message again",
            "emptyFileTransferNotSupported": "The file {0} could not be transferred. Empty files (0 bytes) are not supported.",
            "enterKeyboardShortcut": "Press 2 keys simultaneously to set your new shortcut.",
            "enterSupervisionRoomCode": "Enter the supervision room code",
            "exitFullscreenToReturnToLocalEnvironment": "To exit full screen mode and return to your local environment.",
            "fileTooLargeToTransfer": "The file {0} is too large to be transferred (max {1} MB).",
            "fileTransferredSuccessfully": "The file {0} has been successfully transferred.",
            "finishingTest": "Finishing test...",
            "folderTransferNotSupported": "The folder {0} could not be transferred. Folder upload is not supported. You can compress your folder (ZIP, RAR, etc.) to transfer it.",
            "forceControlTakesOverImmediately": "Take control of the Cloud PC immediately.",
            "fpsOptimizationDescription": "When video optimization is enabled, the number of images per second (FPS) sent adapts to the display needs and saves server resources. Disable it to force a refresh rate of 60 FPS.",
            "groupSessionNoLongerExists": "The group session no longer exists.",
            "impossibleToConnect": "An unexpected error has occurred, please restart the connection. We invite you to contact support if the error persists.",
            "inactivityRemainingMinutes": "0 minutes | 1 minute | {count} minutes",
            "inactivityRemainingSeconds": "0 seconds | 1 second | {count} seconds",
            "iosFullscreenAdvice": "To fully enjoy the experience of our Android Cloud PC, we advise you to switch to full screen mode on your iOS device.",
            "iosFullscreenHomeScreen": "Once the icon is added to your home screen, press it to launch your Cloud PC in full screen.",
            "iosFullscreenShareButton": "To do this, press the 'Share' button at the bottom or top of your screen, then 'On the home screen'.",
            "machineAlreadyInUseBy": "This Cloud PC is already in use by {user}.",
            "machineBeingTakenOver": "The Cloud PC is currently being taken over.",
            "machineEnrolledInSupervisionRoom": "You have joined the supervision room {supervisionRoom}.",
            "machineLocked": "The supervision room administrator locked this machine.",
            "machineNoLongerInSupervisionRoom": "This machine is no longer part of the supervision room.",
            "machineUnlocked": "The Cloud PC has been unlocked.",
            "menuShortcutReminder": "Show menu : {0} + {1}",
            "multipleControlRequestsReceived": "{count} users want to take control of your Cloud PC:",
            "putMachineInSleepModeBeforeLeavingQuestion": "Would you like to put your Cloud PC to sleep before leaving?",
            "rememberToSaveYourWork": "Remember to save your work if necessary.",
            "resolutionNotSupportedByMachineConfig": "This Cloud PC configuration does not allow you to set a specific resolution.",
            "roomSupervisorIsViewingYourMachine": "The room supervisor is now viewing your Cloud PC.",
            "roomSupervisorStoppedViewingYourMachine": "The room supervisor stopped viewing your Cloud PC.",
            "sessionResumedOnAnotherDevice": "A new session has been started on this Cloud PC from another device.",
            "shortcutMustContainTwoKeys": "The shortcut must contain 2 different keys.",
            "singleControlRequestReceived": "A user wants to take control of your Cloud PC:",
            "spiceDriverDegradedPerformance": "The following features on your Cloud PC are degraded because the spice-vdagent driver is not enabled:<br>{0}<br>Please contact support.",
            "streamPausedWaitingForAdmin": "The stream is paused. It will resume when an administrator connects.",
            "supervisedSessionEndsIn": "Your supervised session {name} ends in {time}.",
            "supervisedUserLeftSupervisionRoom": "You can no longer access the supervised user's Cloud PC because they have left the session.",
            "supervisorAllMachinesLocked": "All machines have been locked.",
            "supervisorAllMachinesUnlocked": "All machines have been unlocked.",
            "supervisorMachineLocked": "Cloud PC {machine} has been locked.",
            "supervisorMachineUnlocked": "Cloud PC {machine} has been unlocked.",
            "supportRequestDataInfo": "Some information about the account and the system will be sent to Weytop. We will use them to solve problems and to improve our services. We may ask you for more information if necessary.",
            "supportRequestDescriptionPlaceholder": "Please describe the bug or suggestion in detail.\n\nIn case of a bug, please outline the step-by-step procedure, along with the expected result.",
            "supportRequestFeedbackWarning": "Your feedback is important to us, but please be careful not to share sensitive information.",
            "supportRequestSent": "Your support request has been sent. We will get back to you as soon as possible.",
            "thanks": "Thanks!",
            "updateDetectionInProgress": "Automatic update detection in progress...",
            "usbAgentConnecting": "Connection to the agent in progress...",
            "usbAgentDisconnected": "The agent is no longer connected, you can no longer use your usb devices.",
            "usbAgentError": "An error has occurred, please try again later.",
            "usbAgentGuiDisconnected": "Unable to get list of devices. Are you logged in the Weytop Agent available in the Windows System tray ?",
            "usbAgentNotInstalled": "You don't have the Weytop USB Agent installed or running on your computer. Install it and the connection will be detected automatically.",
            "usbAgentUpdateDetected": "The agent has been updated successfully. You now have the latest version.",
            "usbAgentUpdateNotDetected": "The agent update was not detected automatically. Please verify that the update is complete and reconnect.",
            "usbDeviceConnected": "The device has been connected to your Cloud PC.",
            "usbDeviceDisconnected": "The device has been disconnected from your Cloud PC.",
            "usbDeviceError": "The device could not be connected to your Cloud PC.",
            "usbDevicePending": "The device is connecting.",
            "useMenuToManageCloudPc": "Use the menu to manage your Cloud PC.",
            "userTookControl": "{user} has taken control of this Cloud PC.",
            "useSupportedBrowsersForStreaming": "For a better user experience, use one of our supported browsers:",
            "vdAgentNotAvailable": "The VdAgent service is not available. File transfer is not possible. Please contact support.",
            "waitForUnlock": "Please wait, you will be able to resume using it once the lock is lifted.",
            "webcamConfigError": "Unable to access the webcam. Please check your browser permissions.",
            "youHaveBeenKickedFromSession": "You have been kicked from this session.",
            "youLeftSupervisionRoom": "You have left the supervision room {supervisionRoom}."
        },
        "title": {
            "aboutToLeaveMachine": "You Are About to Leave Your Cloud PC",
            "accessDenied": "Access Denied",
            "clipboardUnavailable": "Can't Copy And Paste",
            "cloudPcPoweredOff": "Cloud PC Powered Off",
            "connectionInterrupted": "Connection Interrupted",
            "contactSupport": "Contact Support",
            "controlForciblyLost": "Forced Control Takeover",
            "controlRequest": "Control Request",
            "controlRequestRefused": "Control Request Refused",
            "controlRequestSent": "Control Request Sent",
            "controlTransferredToUser": "Control Transferred",
            "errorOccurred": "An Error Occurred",
            "groupSession": "Group Session",
            "groupSessionEnded": "Group Session Ended",
            "impossibleToConnect": "Unable to Connect",
            "inactivityWarning": "You Are Inactive",
            "isoDisks": "ISO Disks",
            "machineAlreadyInUse": "Cloud PC Already In Use",
            "machineUnenrolledFromSupervisionRoom": "Cloud PC Left Supervision Room",
            "maintenanceScheduled": "Maintenance Scheduled",
            "maintenancesScheduled": "Maintenances Scheduled",
            "missingSupervisedUser": "Supervised User Missing",
            "networkInfo": "Network Info",
            "noAdminInGroupSession": "No Administrator in Group Session",
            "sendCommand": "Send a Command",
            "sessionEndingApproaching": "Session Ending Soon",
            "sessionEndingImminent": "Session Ending Imminent",
            "sessionResumedOnAnotherDevice": "New Session Detected",
            "someTips": "Some Tips",
            "someTipsForOptimalExperience": "Some Tips for an Optimal Experience",
            "supervisionRoom": "Supervision Room",
            "supervisionRoomEnded": "Supervised Session Ended",
            "takingControl": "Taking Control",
            "transferringControl": "Transferring Control",
            "webcamConfig": "Webcam Configuration",
            "webcamConfigError": "Webcam Error"
        }
    },
    "compatibilityTest": {
        "browser": "Browser",
        "direct": "Direct access",
        "failure": "Incompatible",
        "loading": "Wait a few seconds to determine your configuration...",
        "os": "Operating system",
        "quality": "Connection stability",
        "quality_labels": ["Bad", "Moderate", "Good"],
        "result": {
            "description": "Enter your email address to receive the results of your test and determine if you are eligible for the Weytop offer.",
            "email": "Email",
            "myMail": "My email",
            "title": "Get Your Results"
        },
        "sent": {
            "description": "Check your inbox for test results.",
            "title": "Results Sent"
        },
        "serviceStatus": {
            "reachable": "Service reachable",
            "unreachable": "Service unreachable"
        },
        "skipped": "Skipped",
        "startBtn": "Start the test",
        "streaming": "Streaming",
        "success": "Compatible",
        "title": "Test Your Eligibility to the Weytop Offer",
        "turn": "Turn access"
    },
    "groupSession": {
        "copyLinkSuccess": {
            "content": "The sharing link has been copied to the clipboard.",
            "title": "Sharing Link Copied"
        }
    },
    "handover": {
        "userJoinGroupSession": {
            "message": "{0} joined the session.",
            "title": "User Joined the Group Session"
        },
        "userLeftGroupSession": {
            "message": "{0} left the session.",
            "title": "User Left the Group Session"
        }
    },
    "pendingTransfer": {
        "end": "Finalization ...",
        "title": "Transfers in progress"
    },
    "player": {
        "browserNotCompatible": "Your browser is not compatible with Weytop.",
        "cannotConnectRTC": "Impossible to establish a connection with the server. Please try again later.",
        "compatibleNavigator": "Be sure to update your browser or",
        "downloadLast": "download the latest version of Google Chrome.",
        "unstableConnection": "Your connection is unstable, trying to reconnect..."
    },
    "supervisionRoom": {
        "card": {
            "awaitingPreview": "Preview generation in progress...",
            "connect": "Connect",
            "isFocused": "Window focused",
            "isNotFocused": "Window not focused",
            "lock": "Lock",
            "machineOffline": "Cloud PC offline",
            "machineOut": "Has left the room",
            "unlock": "Unlock",
            "usedBy": "Used by",
            "userHasLeft": "Participant has left the supervision room",
            "userNotConnected": "Participant not connected to the supervision room",
            "userOffline": "User offline"
        },
        "enrolledMachines": "No Cloud PC in the supervision room | 1 Cloud PC in the supervision room | {count} Cloud PCs in the supervision room",
        "machines": {
            "lock": "Lock all Cloud PCs",
            "unlock": "Unlock all Cloud PCs"
        },
        "sort": {
            "default": "Sort by",
            "joinedAsc": "Last joined",
            "joinedDesc": "First joined",
            "nameAsc": "Name (A-Z)",
            "nameDesc": "Name (Z-A)"
        }
    }
}
